import React      from 'react';
import ReactDom   from 'react-dom';

import Const      from 'fw_const';
import Utils      from 'utils';

import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';
// -------------------------------------------------------

class ProfilingCategory extends React.Component {
  render() {
    let category = this.props.category;
    
    let json = JSON.parse(category);
    
    let mstObj = {};
    let mst = Const.value.categoryMst;
    mst.map((d) => { mstObj[d.id] = d; });
    
    // リストの生成
    let sum  = 0;
    json.map((d, key) => {
      if( key < 5 || d.per == 0 ) sum += d.per;
    });
    
    let data = [];
    let check = 0;
    json.map((d, key) => {
      if( key >= 5 || d.per == 0 ) return;
      
      let value = 0;
      try { value = Math.round((d.per / sum) * 100); } catch(e) {}
      
      // カテゴリー設定
      let obj = mstObj[d.id];
      data.push({ id: d.id, name: obj.name, value: value });
      
      check += value;
    });
    
    // 端数処理
    try { data[0].value = (data[0].value + (100 - check)); } catch(e) {}
    
    let colors = [];
    if( this.props.type == 'my'       ) colors = ["#306143", "#3f906b", "#56c28a", "#8af5a8", "#beffd8", "#f2fff9"];
    if( this.props.type == 'follower' ) colors = ["#2a2b5e", "#3d488b", "#4a71bc", "#589fef", "#90d0ff", "#c3ffff"];
    
    return (
      <div className={'categorys-list '+ this.props.type}>
        
        <h5><b>{this.props.title}</b></h5>
        
        <div className="pie-chart">
          <PieChart width={180} height={180}>
            <Pie dataKey="value" data={data} isAnimationActive={false} startAngle={90} endAngle={-270} innerRadius={60} outerRadius={80} paddingAngle={3}>
              { data.map((entry, index) => <Cell key={index} fill={colors[index % colors.length]}/>) }
            </Pie>
            <Tooltip />
          </PieChart>
          
          { (data[0] != undefined) ? <p className={'category_img c_'+ data[0].id} /> : null }
        </div>
        
        <ul>
          { data.map((d, key) => {
            let value = d.value;
            
            return (
              <li key={key}>
                <div className="category-name">
                  <p className="bar" style={{ background: colors[key] }} />
                  <p className={'category_img c_'+ d.id} />
                  <h3 className="name">{d.name}</h3>
                  <h5 className="per">- {value}%</h5>
                </div>
              </li>
            );
          })}
        </ul>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProfilingCategory;